module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EFEFEF",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "activity-top-box"
  }, [_c('div', {
    staticClass: "activity-title"
  }, [_vm._v(_vm._s(_vm.diaryDetail.title) + "冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！")]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-names"
  }, [_vm._v(_vm._s(_vm.userInfo.name) + "冠顶饺")]), _vm._v(" "), _c('div', {
    staticClass: "look-info"
  }, [_vm._v(_vm._s(_vm._f("getTimeFormat")(_vm.diaryDetail.create_time)) + " 68阅读")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-right",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("分享")])]), _vm._v(" "), _c('div', {
    staticClass: "activity-desc"
  }, [_vm._v("\n\t\t\t冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "release-time"
  }, [_vm._v(_vm._s(_vm._f("getTimeFormat")(1590045030)))])]), _vm._v(" "), _c('div', {
    staticClass: "zan-box"
  }, [_c('span', {
    staticClass: "zan-num"
  }, [_vm._v("90赞")]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('img', {
      key: i,
      staticClass: "user-zan-face",
      attrs: {
        "src": require("../../assets/images/activity/pic-logo1@2x.png"),
        "alt": ""
      }
    })
  })], 2), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "comments-box"
  }, [_c('div', {
    staticClass: "comments-box-title"
  }, [_vm._v("评论")]), _vm._v(" "), _c('div', {
    staticClass: "comments-list-box"
  }, _vm._l((3), function(i) {
    return _c('div', {
      key: i,
      staticClass: "comments-list"
    }, [_c('div', [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-names"
    }, [_vm._v(_vm._s(_vm.userInfo.name) + "冠顶饺")]), _vm._v(" "), _c('div', {
      staticClass: "look-info"
    }, [_vm._v(_vm._s(_vm._f("getTimeFormat")(1590045030)) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "comments-content"
    }, [_vm._v("好奥哈后哈哈哈")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "send-comments"
  }, [_c('van-field', {
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.commentsPlaceholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('van-image-preview', {
    attrs: {
      "images": _vm.images
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-face"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-logo1@2x.png"),
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-place-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/Shape@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-place"
  }, [_vm._v("南京新街口")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interactive-box"
  }, [_c('div', {
    staticClass: "interactive-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/icon-toupiao@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "interactive-info"
  }, [_c('p', {
    staticClass: "interactive-info-title"
  }, [_vm._v("评选最佳观众投票")]), _vm._v(" "), _c('p', {
    staticClass: "interactive-info-desc"
  }, [_vm._v("啦啦操总决赛评选最佳观众有机会获取大奖哦~")])]), _vm._v(" "), _c('div', {
    staticClass: "interactive-solid"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "interactive-btn"
  }, [_vm._v("\n\t\t\t\t\t\t立即参与\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "interactive-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/icon-zhibo@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "interactive-info"
  }, [_c('p', {
    staticClass: "interactive-info-title"
  }, [_vm._v("总决赛直播进行中")]), _vm._v(" "), _c('p', {
    staticClass: "interactive-info-desc"
  }, [_vm._v("点击这里进入专属直播通道~~")])]), _vm._v(" "), _c('div', {
    staticClass: "interactive-solid"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "interactive-btn"
  }, [_vm._v("\n\t\t\t\t\t\t立即参与\n\t\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-face"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-logo1@2x.png"),
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-btn"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/icon-zan.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167404e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/activity/ActivityDetail.vue
// module id = 1335
// module chunks = 0